import namespace from '@/helpers/namespace';

export default namespace('global', {
  actions: [
    'changeLanguage',
    'vendorId',
    'vendor',
    'reservation'
  ],
  getters: [
    'language',
    'multiLanguage',
    'vendorUrl',
    'url',
    'vendorId',
    'idVendor',
    'vendor',
    'online',
    'reservation',
    'width',
    'height',
    'socket',
    'loadingGeneral'
  ],
  mutations: [
    'startProcessing',
    'stopProcessing',
    'setLanguage',
    'setMultiLanguage',
    'setVendorUrl',
    'setOnline',
    'setVendor',
    'setVendorId',
    'setId',
    'setReservation',
    'setWidth',
    'setHeight',
    'setSocket',
    'setUrl',
    'setLoadingGeneral'
  ]
});
